module.exports = __webpack_public_path__ + "media/components/nearby-points/static/photo-4-fa3a2acd8260f39525ad502daacbca2a.jpg";